import React, { useState } from 'react';
import cn from 'classnames';
import Checkbox from '../../../../../../../components/common/checkbox';
import { bbCodeToHtml } from '../../../../../../../utils/formUtils';
import { Visibility } from '../../../../../../../types/common-types';
import './style.scss';

interface ValueProps {
  id: string;
  value: boolean;
  error: boolean;
}

interface Props {
  id: string;
  title?: string;
  value: boolean;
  error?: boolean;
  required?: boolean;
  errorMsg?: string;
  helpMsg?: string;
  style?: object;
  visibility?: Visibility;
  onSubmit: (id: string) => void;
  onChange: (value: ValueProps, callback?: () => void) => void;
  submitOnChange?: boolean;
}

const CheckboxBF: React.FC<Props> = ({
  id,
  title,
  value,
  visibility,
  required,
  errorMsg,
  helpMsg,
  error,
  style,
  submitOnChange = false,
  onChange,
  onSubmit,
}) => {
  const [expanded, setExpanded] = useState(false);
  const [expandedUpArrow, setExpandedUpArrow] = useState(false);

  const toggleExpand = (
    event: React.MouseEvent<HTMLSpanElement>,
    isUpArrow: boolean
  ) => {
    event.preventDefault();
    if (isUpArrow) {
      setExpanded(false);
      setExpandedUpArrow(!expandedUpArrow);
    } else {
      setExpanded(!expanded);
      setExpandedUpArrow(false);
    }
  };

  let symbolCount = 0;
  let trimmedTitle = '';

  if (title) {
    const urlTagsRemoved = title.replace(/\[url=[^\]]+\]|\[\/url\]/g, '');
    symbolCount = urlTagsRemoved.length;

    if (expanded) {
      trimmedTitle = title;
    } else if (symbolCount > 200) {
      trimmedTitle = urlTagsRemoved.slice(0, 200) + '...';
    } else {
      trimmedTitle = urlTagsRemoved;
    }
  }
  const handleOnChange = (data: ValueProps) => {
    onChange(data, () => {
      if (submitOnChange) onSubmit(id);
    });
  };

  return (
    <Checkbox
      id={id}
      styleName={cn('check')}
      visibility={visibility}
      value={value}
      error={error}
      style={style}
      required={required}
      onChange={handleOnChange}
      helperText={error ? errorMsg : helpMsg}
    >
      {title && symbolCount > 200 && (
        <span
          onClick={event => toggleExpand(event, false)}
          className="down-arrow"
        >
          ▼
        </span>
      )}
      {title && symbolCount > 200 && expanded && (
        <span onClick={event => toggleExpand(event, true)} className="up-arrow">
          ▲
        </span>
      )}
      <span
        dangerouslySetInnerHTML={{
          __html: bbCodeToHtml(trimmedTitle),
        }}
      />
    </Checkbox>
  );
};

export default CheckboxBF;
